import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Cta, CtaModule } from '@rogers/cdk/assembled/cta';
import { CheckboxChange, FormModule, RadioChange } from '@rogers/cdk/form';
import { CommonModule } from '@angular/common';

export type MenuItemType = 'switch' | 'radio' | 'link';
export interface SelectItem {
  label: string;
  value;
}

@Component({
  standalone: true,
  selector: 'ucx-header-menu-item',
  templateUrl: './header-menu-item.component.html',
  styleUrls: ['./header-menu-item.component.scss'],
  imports: [FormModule, CommonModule, CtaModule],
})
export class HeaderMenuItemComponent implements OnInit {
  @Input() menuItemText = '';
  @Input() menuItemLabel = '';
  @Input() menuItemKey = '';
  @Input() menuItemType: MenuItemType | undefined;
  @Input() menuItemOptions: SelectItem[] = [];
  @Input() selectedMenuItemOption;
  @Input() isMenuItemVisible = true;

  @Output() menuItemChanged = new EventEmitter<any>();

  ctaData: Cta = {
    copy: 'Title',
    variant: 'cta',
    alt: 'Title',
  };

  ngOnInit() {
    this.ctaData = {
      copy: this.menuItemText,
      variant: 'cta',
      alt: this.menuItemLabel,
    };
  }

  isMenuItemTypeSwitch(): boolean {
    return this.menuItemType === 'switch';
  }
  isMenuItemTypeRadioSelection(): boolean {
    return this.menuItemType === 'radio';
  }
  isMenuItemTypeLink(): boolean {
    return this.menuItemType === 'link';
  }

  isSwitchVisible(): boolean {
    return this.isMenuItemTypeSwitch() && this.menuItemOptions?.length === 2;
  }

  isRadioVisible(): boolean {
    return (
      this.isMenuItemTypeRadioSelection() && this.menuItemOptions?.length === 2
    );
  }

  isChatTranscriptEnabled(): boolean {
    return this.isMenuItemVisible;
  }

  emitSwitchChanges(event: CheckboxChange): void {
    this.menuItemChanged.emit({ key: this.menuItemKey, value: event.checked });
  }

  emitRadioChanges(event: RadioChange): void {
    this.menuItemChanged.emit({ key: this.menuItemKey, value: event.value });
  }

  emitLinkClicked(): void {
    this.menuItemChanged.emit({ key: this.menuItemKey, value: null });
  }
}
